const normalizedSizeSystemNames = {
  kids: { regexp: /kids age \(years\)/gim, normalizedName: 'Age' }
};

const normalizedSizeValueNames = {
  kidsYears: { regexp: /(\d+)y/gim, normalizedName: '$1 YRS' },
  kidsMonthsRange: { regexp: /(\d+)-(\d+)(.*)/, normalizedName: '$1 - $2$3' },
  kidsMonths: { regexp: /(\d+)m/, normalizedName: '$1 M' }
};

const normalizedSizeValueForCartOnly = {
  kids: { regexp: /^years /gim, normalizedName: '' }
};

const monthsRegexp = /^.+M\s*$/;
const yearsRegexp = /^.+Y\s*$/;
const anythingRegexp = /[\s\S]*/;
const sizeSelectorOptionsOrder = {
  babyDualAge: {
    regexp: /^Baby Dual Age \(Months\)$/,
    optionsOrder: [monthsRegexp, yearsRegexp, anythingRegexp]
  },
  default: {
    regexp: anythingRegexp,
    optionsOrder: [anythingRegexp]
  }
};

const normalizingReducer = (acc, { regexp, normalizedName }) => acc.replace(regexp, normalizedName);

const normalizeSizeSystemName = (sizeSystemName = '') =>
  Object.values(normalizedSizeSystemNames).reduce(normalizingReducer, sizeSystemName);

const normalizeSizeValueName = (sizeValueName = '') =>
  Object.values(normalizedSizeValueNames).reduce(normalizingReducer, sizeValueName);

const normalizeSizeValueForCart = (sizeSystemName = '') =>
  Object.values(normalizedSizeValueForCartOnly).reduce(normalizingReducer, normalizeSizeSystemName(sizeSystemName));

const stableSortOptions = (options, optionsOrder) => {
  const optionsByRegexp = {};
  optionsOrder.forEach(optionRegexp => {
    optionsByRegexp[optionRegexp] = [];
  });

  options.forEach(option => {
    optionsOrder.some(optionRegexp => {
      const { rawSize } = option;
      if (rawSize.match(optionRegexp)) {
        optionsByRegexp[optionRegexp].push(option);
        return true;
      }
      return false;
    });
  });

  const sortedOptions = [];
  optionsOrder.forEach(optionRegexp => {
    const optionsArr = optionsByRegexp[optionRegexp];
    sortedOptions.push(...[].concat.apply(optionsArr));
  });
  return sortedOptions;
};

const normalizeSizeSelectorOptionsOrder = (sizeSelectorOptions, sizeUnitSystem) => {
  let sortedOptions = [];

  Object.values(sizeSelectorOptionsOrder).some(({ regexp, optionsOrder }) => {
    if (sizeUnitSystem.match(regexp)) {
      sortedOptions = stableSortOptions(sizeSelectorOptions, optionsOrder);
      return true;
    }
    return false;
  });

  return sortedOptions;
};

export {
  normalizeSizeSystemName,
  normalizeSizeValueName,
  normalizeSizeValueForCart,
  normalizeSizeSelectorOptionsOrder
};
